module.exports = __webpack_public_path__ + "static/confused-ccb3b56f6db1c927c825829423b995dd.gif";